import { buildURI, useFetch } from '@hn-front/utils';
import { CURRICULUM_API_ROUTES } from '../constants/routes';
var useFetchCurriculumGrade = function (gradeName) {
    return useFetch(gradeName
        ? buildURI(CURRICULUM_API_ROUTES.curriculumGrade, {
            pathParams: { gradeName: gradeName },
        })
        : undefined);
};
export { useFetchCurriculumGrade };
